<template>
  <div v-if="initiated" class="admin">
    <Menu />
    <h3>
      Modération Restants <span v-if="annonces">({{ annonces.length }} annonces à modérer)</span>
    </h3>
    <!--     <div>
      <input type="checkbox" id="empty" />
      <label for="empty"></label>
    </div> -->
    <div class="conteneurModeration">
      <div v-for="an in annonces" :key="an.prf.id" class="modItem">
        <div class="conteneurCadre">
          <div class="photoIP">
            <PhotoDetail :prf="an.prf" :usr="an.user">
              <InfosIp :prf="an.prf" :usr="an.user" :sniped="an" />
            </PhotoDetail>

            <span class="brout" v-if="an.prf.suspect">Ce profil a été détecté comme "brouteur" et sera nettoyé</span>
          </div>
        </div>
        <div class="annonces">
          <EditableArea
            :id="`quelquesmots${an.prf.id}`"
            :prompt="'Quelques mots sur moi...'"
            :text="an.prf.shortDescriptionToValidate || an.prf.shortDescription"
            :ref="`quelquesmots${an.prf.id}`"
            :edit="false"
            :admin="true"
          />

          <EditableArea
            :id="`jerecherche${an.prf.id}`"
            :prompt="'Ce que je recherche'"
            :text="an.prf.longDescriptionToValidate || an.prf.longDescription"
            :ref="`jerecherche${an.prf.id}`"
            :edit="false"
            :admin="true"
          />
        </div>
        <div class="actions">
          <button class="bouton" @click="validateTexts(an.prf)"><img src="/assets/icons/check.png" /> Valider</button>
          <button class="bouton" @click="verify(an.prf.id)"><img src="/assets/icons/eyes.png" /> Vérifier</button>
          <button class="bouton" @click="kickProfile(an.prf)"><img src="/assets/smiley/angry.png" /> Kicker</button>
          <button class="bouton" @click="banProfile(an.prf.id)"><img src="/assets/smiley/angry2.png" /> Bannir</button>
          <button class="bouton" disabled><img src="/assets/icons/bulle.png" /> Chat Log</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/admin/Menu.vue";
import BasePage from "@/components/pages/BasePage";

import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import InfosIp from "@/components/admin/InfosIp.vue";
import PhotoDetail from "@/components/admin/PhotoDetail.vue";
import EditableArea from "@/components/profile/EditableArea.vue";
import Vue from "vue";

export default {
  name: "AdminPhotos",
  components: { Menu, InfosIp, PhotoDetail, EditableArea },
  extends: BasePage,
  data() {
    return { annonces: null, empty: false };
  },

  methods: {
    async routeEnter() {
      this.annonces = await idyuJsonRpc("getProfilesToValidate");

      for (let an of this.annonces) {
        let user = await idyuJsonRpc("getUser", an.prf.id);
        this.$set(an, "user", user);
      }

      await Vue.nextTick();

      if (this.$refs.jerecherche) {
        this.$refs.jerecherche.refresh();
      }
      if (this.$refs.quelquesmots) {
        this.$refs.quelquesmots.refresh();
      }
    },

    removeIdProfile(idProfile) {
      this.annonces = this.annonces.filter(elt => elt.prf.id != idProfile);
    },

    async validateTexts(prf) {
      idyuJsonRpc("validateProfile", prf.id);
      this.removeIdProfile(prf.id);
    },

    kickProfile(prf) {
      idyuJsonRpc("kickProfile", prf.pseudo);
      this.removeIdProfile(prf.id);
    },

    banProfile(idProfile) {
      idyuJsonRpc("banProfile", idProfile);
      this.removeIdProfile(idProfile);
    },

    shortChanged: function(prf, val) {
      prf.shortDescriptionToValidate = val;
    },

    longChanged: function(prf, val) {
      prf.longDescriptionToValidate = val;
    },

    verify(idProfile) {
      this.$router.push({ name: "AdminUsers", query: { id: idProfile } });
    }
  }
};
</script>

<style scoped>
.conteneurModeration {
  display: grid;
  grid-gap: 10px;
  align-items: baseline;
}

.conteneurCadre {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 10px;
  justify-content: left;
}

.modItem {
  border-bottom: 1px #555 dotted;
  padding-bottom: 10px;
}

.photoDetails {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 5px;
  grid-template-columns: auto 1fr;
}

.photoIP {
  display: grid;
  grid-gap: 5px;
}

.actions {
  margin-top: 10px;
  display: flex;
}

.actions button {
  margin-right: 10px;
  min-width: 120px;
}

button img {
  margin-right: 10px;
}

.brout {
  font-style: italic;
  color: rgb(153, 99, 0);
}

.annonces {
  margin-top: 10px;
  display: grid;
  grid-gap: 10px;
}
</style>
